import script from "./AtendimentoWhatsappRepository.vue?vue&type=script&lang=js"
export * from "./AtendimentoWhatsappRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__